import React, { useEffect, useState } from 'react';
import { Form, FormFeedback, Input } from 'reactstrap';
import { BaseCustomModal, GradientDecorationLine, BaseCustomButton, BaseSelectComponent } from '../../../shared';
import { useFormik } from "formik";
import * as Yup from "yup";
import Switch from "react-switch";
import { Offsymbol, OnSymbol } from '../../../constants/holcim';

export const SurveyConceptRegisterModal = ({ setShowModal, showModal, modalRespInfo, isUpdate, rowInfo, surveyCategories, modalClose }) => {

    const [active, setActive] = useState(false);
    const [lockActive, setLockActive] = useState(false);

    useEffect(() => {
        if (isUpdate) {
            setActive(rowInfo.recordStatus);
            setLockActive(false);
        } else {
            setActive(true);
            setLockActive(true);
        }
    }, [showModal, isUpdate, rowInfo]);

    const formikFormData = useFormik({
        enableReinitialize: true,
        initialValues: {
            concept: isUpdate ? rowInfo.concept : '',
            surveyCategory: isUpdate ? rowInfo.surveyCategory?.id : null,
        },
        validationSchema: Yup.object({
            concept: Yup.string().required("Ingrese el concepto de la encuesta de satisfacción"),
            surveyCategory: Yup.string().required("Seleccione una categoría de encuesta de satisfacción"),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values, active);
            resetForm();
            setShowModal(false);
        }
    });

    const onClosed = () => {
        formikFormData.resetForm();
        modalClose();
        setShowModal(false);
    };

    const children_form = (
        <div>
            <h4 className="text-primary m-0 ps-4">Registro/Actualización de Conceptos de Encuestas de Satisfacción</h4>
            <GradientDecorationLine />
            <Form onSubmit={formikFormData.handleSubmit}>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Concepto de Encuesta de Satisfacción</label>
                    <Input
                        name="concept"
                        className="form-control text-primary"
                        placeholder="Concepto de Encuesta de Satisfacción"
                        type="text"
                        {...formikFormData.getFieldProps('concept')}
                        invalid={formikFormData.touched.concept && !!formikFormData.errors.concept}
                    />
                    {formikFormData.touched.concept && formikFormData.errors.concept && (
                        <FormFeedback>{formikFormData.errors.concept}</FormFeedback>
                    )}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Categoría de Encuesta de Satisfacción</label>
                    <BaseSelectComponent
                        options={surveyCategories.map((category) => ({ value: category.id, label: category.name }))}
                        value={formikFormData.values.surveyCategory}
                        onChange={(value) => formikFormData.setFieldValue("surveyCategory", value)}
                        placeholder="Seleccione una categoría"
                        error="Seleccione una categoría de encuesta de satisfacción"
                        touched={formikFormData.touched.surveyCategory && formikFormData.errors.surveyCategory}
                        status={formikFormData.touched.surveyCategory && formikFormData.errors.surveyCategory ? 'error' : ''}
                    />
                </div>
                <div className="px-5">
                    <div className='text-primary pb-2'>Activo</div>
                    <Switch
                        disabled={lockActive}
                        className='me-4'
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        onColor="#94C12E"
                        onChange={() => setActive(!active)}
                        checked={active}
                    />
                </div>
                <div className='mt-5'>
                    <GradientDecorationLine />
                    <div className="page-title-box d-flex justify-content-end">
                        <BaseCustomButton
                            outline
                            color="primary"
                            className='rounded-3 me-4'
                            onClick={formikFormData.handleSubmit}
                            label="Guardar"
                            icon="mdi mdi-content-save me-1"
                        />
                        <BaseCustomButton
                            outline
                            color="danger"
                            className='rounded-3'
                            onClick={() => onClosed()}
                            label="Cancelar"
                            icon="mdi mdi-close-circle-outline me-1"
                        />
                    </div>
                </div>
            </Form>
        </div>
    );

    return <BaseCustomModal isModalOpen={showModal} handleCancel={onClosed} footer={null} children={children_form} width={700} />;
};
